import { render } from "./CreateMappingModal.vue?vue&type=template&id=ec7af41c&ts=true"
import script from "./CreateMappingModal.vue?vue&type=script&lang=ts"
export * from "./CreateMappingModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__